import styled from 'styled-components';
import StatusTag from '@/components/StatusTag';

export const ContactLink = styled.a<{ isDisabled?: boolean }>`
  width: 100%;
  color: ${(props) =>
    props.isDisabled ? props.theme.colors['neutral-90'] : props.theme.colors['primary-60']};
  display: flex;
  line-height: 21px;
  align-items: center;
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'initial')};

  svg {
    color: ${(props) =>
      props.isDisabled
        ? props.theme.colors['neutral-90']
        : props.theme.colors['primary-60']} !important;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const CandidateContact = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex: ${(props) => (props.fullWidth ? 1 : 'initial')};
  justify-content: space-between;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: 500px;
    border-left: 1px solid;
    padding-left: 20px;
    margin-left: 20px;
    border-color: ${(props) => props.theme.colors['neutral-30']};
  }
`;

export const ContactInfo = styled.div`
  display: flex;
  width: 100%;
  font-size: 14px;
  line-height: 21px;
  margin-bottom: 4px;
  align-items: center;

  svg {
    margin-right: 6px;
    font-size: 15px;
    color: ${(props) => props.theme.colors['neutral-100']};
  }

  p {
    color: ${(props) => props.theme.colors['neutral-100']};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 50%;
    margin-bottom: 0px;
  }
`;

export const Tag = styled(StatusTag)`
  margin-right: 12px;
  display: flex;
`;

export const Box = styled.div`
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  background-color: ${(props) => props.theme.colors['neutral-10']};
  padding: 25px;
  margin: 0 -20px 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    justify-content: space-between;
    display: flex;
    align-items: center;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 25px 105px;
    margin: 0 -100px 16px;
  }
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
`;

export const SpaceBetween = styled.div`
  &:not(:last-of-type) {
    margin-right: 40px;
  }
`;

export const InfoResume = styled(Info)`
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-bottom: 0;
  }
`;

export const FintechExperienceIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 12px;
  border-radius: 50%;
`;

export const CandidateName = styled.h3`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 600;
  line-height: 18px;
  font-size: 16px;
  margin-right: 12px;
  margin-bottom: 4px;
`;

export const SimpleText = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 400;
  line-height: 21px;
  font-size: 14px;
  text-transform: capitalize;
`;

export const SmallerText = styled(SimpleText)`
  font-size: 12px;
  font-weight: 600;
  line-height: 16.32px;
`;
